<template>
  <Header></Header>
  <div class="main-height">
    <section class="card-select">
      <div class="container">
        <div class="inner-container">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <img class="lock-img mb-4" src="../assets/lock.png" alt="">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <p class="mb-0">Step <span class="fw-bold">3</span> of <span class="fw-bold">3</span>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <h1 class="fw-bold text-center mt-1">
                  Choose how to pay
                </h1>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <p>
                  Your payment is encrypted, and your card information is never stored on our servers.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <h5>Secure for peace of mind.</h5>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">
                No auto-renewals.
              </h5>
            </div>
          </div>
          <div v-if="planId != ''" class="row mt-2">
            <div class="col-12">
              <div class="img-fluid d-flex justify-content-end align-items-center encryption">
                <p class="mt-1 mb-0">End-to-end encrypted</p>
                <img class="secure-server mx-1 my-1" src="../assets/lock2.svg" alt="">
              </div>
            </div>
          </div>
          <div v-else class="alert-danger mt-3 ps-3 pe-3">
            Please choose a plan before continuing with the payment.
          </div>
          <div v-if="planId != ''">
            <div class="row" v-if="['stripe', 'cPay', 'square', 'whatsapp'].includes(paymentMethod)">
              <div class="col-12">
                <div class="underline">
                  <a @click.prevent="!paymentMethodClicked && doCardPayment()" :class="{ 'is-disabled': paymentMethodClicked }">
                    <div class="card w-100 payment-card-button" role="button">
                      <div class="row">
                        <div class="col-10">
                          <p class="ms-3 mt-3">
                            <span class="me-2">Credit or Debit Card</span>
                            <img class="img-fluid cards-img" src="../assets/visa-card.png" alt="">
                          </p>
                        </div>
                        <div class="col-2 my-auto">
                          <div class="card-arrow-img">
                            <img class="card-arrow" src="../assets/arrow.svg" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="paymentMethod === 'paypalSDK'">
              <div class="col-12">
                <div class="underline">
                  <a @click.prevent="!paymentMethodClicked && doPaypalSDKPayment()" :class="{ 'is-disabled': paymentMethodClicked }">
                    <div class="card w-100 payment-card-button" role="button">
                      <div class="row align-items-center">
                        <div class="col-10">
                          <p class="ms-3 mt-3">
                            <span class="me-2">Credit or Debit Card</span>
                            <img  class="paypal-img" src="../assets/paypal-small.png" alt="">
                            <img class="img-fluid paypal-img" src="../assets/visa-card-small.png" alt="">
                          </p>
                        </div>
                        <div class="col-2 my-auto">
                          <div class="card-arrow-img">
                            <img class="card-arrow" src="../assets/arrow.svg" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="userPlan != null && !userPlan.trial && !(paymentMethod === 'paypalSDK')">
              <div class="col-12">
                <div class="underline">
                  <a @click.prevent="!paymentMethodClicked && doPaypalPayment()" :class="{ 'is-disabled': paymentMethodClicked }">
                    <div class="card w-100 payment-card-button" role="button">
                      <div class="row">
                        <div class="col-10">
                          <p class="ms-3 mt-3">
                            <img  class="paypal-img" src="../assets/paypal.png" alt="">
                          </p>
                        </div>
                        <div class="col-2 my-auto">
                          <div class="card-arrow-img">
                            <img class="card-arrow" src="../assets/arrow.svg" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <div class="underline">
                  <a @click.prevent="!paymentMethodClicked && doPlisioPayment()" :class="{ 'is-disabled': paymentMethodClicked }">
                    <div class="card w-100 payment-card-button" role="button">
                      <div class="row align-items-center">
                        <div class="col-10">
                          <p class="ms-3 mt-3">
                            <span class="me-2">Cryptocurrency</span>
                            <img class="paypal-img" src="../assets/bitcoin-btc-logo.png" alt="Bitcoin" />
                            <img class="paypal-img" src="../assets/ethereum-eth-logo.png" alt="Ethereum" />
                            <img class="paypal-img" src="../assets/tether-usdt-logo.png" alt="Tether" />
                          </p>
                        </div>
                        <div class="col-2 my-auto">
                          <div class="card-arrow-img">
                            <img class="card-arrow" src="../assets/arrow.svg" alt="">
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 mt-4">
              <div class="activated">
                <button class="btn text-white w-100 rounded-1" @click="doPlans">CHOOSE A PLAN</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <Footer></Footer>
</template>

<script>
import {defineComponent} from 'vue'
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AuthService from '@/services/auth-service'
import StripeService from "@/services/stripe-service";
import PaypalService from "@/services/paypal-service";
import PlisioService from "@/services/plisio-service";
import CpayService from "@/services/cpay-service";
import SquareService from "@/services/square-service";

export default defineComponent({
  name: "Secure payment",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      planId: '',
      error: '',
      userPlan: null,
      paymentMethod: 'stripe',
      paymentMethodClicked: false,
      whatsAppOrderId: '',
    }
  },
  methods: {
    doPlans() {
      this.$router.push('/plans')
    },
    doSignOut() {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    },
    // Unified handler for stripe, cPay, square and whatsapp.
    // Reads sessionStorage to decide which service to call and how to build the URL.
    async doCardPayment() {
      if (this.paymentMethodClicked) return;
      this.paymentMethodClicked = true;
      const method = sessionStorage.getItem('paymentMethod') || this.paymentMethod;

      if (method === 'whatsapp') {
        try {
          this.whatsAppOrderId = await CpayService.getOrderId(this.planId);
          if (this.whatsAppOrderId != null) {
            sessionStorage.setItem('whatsAppOrderId', this.whatsAppOrderId);
            this.$router.replace('/whatsapp-payment');
          }
        } catch (error) {
          this.error = 'Error: ' + error;
        } finally {
          this.paymentMethodClicked = false;
        }
        return;
      }

      // Open blank tab immediately from user click so browsers don't block it
      const paymentWindow = window.open('', '_blank');
      if (!paymentWindow) {
        this.paymentMethodClicked = false;
        this.error = 'Popup/tab was blocked by the browser';
        return;
      }
      try {
        let url;
        if (method === 'stripe') {
          url = await StripeService.getPaymentUrl(this.planId);
        } else if (method === 'cPay') {
          url = await CpayService.getPaymentUrl(this.planId);
        } else if (method === 'square') {
          url = await SquareService.getPaymentUrl(this.planId);
        } else {
          throw new Error('Unknown payment method: ' + method);
        }
        if (url === 'false') throw new Error('Could not get payment URL');
        // Append token uniformly for all card providers
        const finalUrl = new URL(url);
        finalUrl.searchParams.set('token', localStorage.getItem('access_token'));
        paymentWindow.location.href = finalUrl.toString();
        this.$router.replace('/payment-in-progress');
      } catch (error) {
        this.paymentMethodClicked = false;
        this.error = 'Error: ' + error;
        paymentWindow.close();
      }
    },
    doPaypalPayment() {
      if (this.paymentMethodClicked) return;
      this.paymentMethodClicked = true;
      PaypalService.getPaymentUrl(this.planId).then((paypalUrl) => {
        if (paypalUrl != "false") {
          window.location = paypalUrl + "&token=" + localStorage.getItem('access_token') + "&redirectUrl=" + location.hostname
        }
      }).catch((error) => {
        this.paymentMethodClicked = false;
        this.error = 'Error: ' + error
      })
    },
    doPaypalSDKPayment() {
      if (this.paymentMethodClicked) return;
      this.paymentMethodClicked = true;
      PaypalService.getPaymentUrlV2(this.planId).then((paypalUrl) => {
        if (paypalUrl != "false") {
          window.location = paypalUrl + "&token=" + localStorage.getItem('access_token') + "&redirectUrl=" + location.hostname
        }
      }).catch((error) => {
        this.paymentMethodClicked = false;
        this.error = 'Error: ' + error
      })
    },
    doPlisioPayment() {
      if (this.paymentMethodClicked) return;
      this.paymentMethodClicked = true;
      PlisioService.getPaymentUrl(this.planId).then((plisioUrl) => {
        if (plisioUrl != "false") {
          window.location = plisioUrl
        }
      }).catch((error) => {
        this.paymentMethodClicked = false;
        this.error = 'Error: ' + error
      })
    },
  },
  beforeMount() {
    if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'));
    // prevent direct navigation bugs
    if (localStorage.getItem('userProfile') == null) {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    }
    if (localStorage.getItem('chosenPlan')) {
      this.planId = localStorage.getItem('chosenPlan')
    } else {
      this.$router.push('/plans')
    }
    if (sessionStorage.getItem('paymentMethod')) this.paymentMethod = sessionStorage.getItem('paymentMethod');
  },
  mounted() {
    this._onPageShow = () => { this.paymentMethodClicked = false; };
    window.addEventListener('pageshow', this._onPageShow);
  },
  beforeUnmount() {
    window.removeEventListener('pageshow', this._onPageShow);
  },
})
</script>

<style>
@import '../assets/style.css';
</style>
